import Papa from "papaparse";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
export const downloadCSV = (data, filename = "data.csv") => {
  if (!data || !data.length) {
    console.warn("No data to export");
    return;
  }

  const csv = Papa.unparse(data); // handles headers & escaping
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, filename.endsWith(".csv") ? filename : `${filename}.csv`);
};


// for downloading weekly  csv
export const downloadSingleReservations = (params,startDate,endDate) => {
  try {
    const data = params;
    let filename =`${startDate}-${endDate}-reservations.xlsx`
const formatted = data.map(({
  cost, status, limitPerUser, id, paidAmount, deductionComment, deductionAmount,
  platformFee, aggregatedPlatformFee, platformFeeCollected,
  ...item
}) => {
  const feeCollected   = platformFeeCollected || 0;
  const rawCollected = item.PaymentCollectedFromCustomer || 0;
const feeCharged = platformFee || 0; 


  return {
    ...item,
    PaymentCollectedFromCustomer:  rawCollected - feeCollected,
    amountToBePaidByThc:
          rawCollected
           - feeCharged
    + (item?.thcCouponAmt || 0)
    + (item?.thcCoinAmt || 0)
      + (item.thcDiscount || 0)
      + (item?.thcAppDiscount || 0)
      - (item.comissionAmt || 0)
  };
});

    const worksheet = XLSX.utils.json_to_sheet(formatted);

const colWidths = Object.keys(formatted[0]).map(key => {
  const maxValLength = Math.max(
    key.length,
    ...formatted.map(row => String(row[key] || '').length)
  );

  return { wch: maxValLength  }; 
});

worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reservation");

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, filename);
  } catch (error) {
    console.error("Error exporting reservation Excel:", error);
  }
};
